import React from "react";

const ProjectItem = ({ project, onClick }) => {
  return (
    <div className="project-item-wrapper" onClick={onClick}>
      <div className="project-card-stack">
        {/* Left: text content */}
        <div className="project-card-info">
          <div className="project-card-meta">
            <span className="project-card-category">{project.category}</span>
            <span className="project-card-year">{project.year}</span>
          </div>

          <h3 className="project-card-title">{project.title}</h3>
          <p className="project-card-description">{project.description}</p>

          <div className="project-card-tech">
            {project.tech.map((tech, idx) => (
              <span key={idx} className="project-card-tech-badge">
                {tech}
              </span>
            ))}
          </div>

          <button className="project-card-cta" onClick={onClick}>
            <span>See more</span>
            <svg
              width="22"
              height="12"
              viewBox="0 0 22 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.5303 6.53033C21.8232 6.23744 21.8232 5.76256 21.5303 5.46967L16.7574 0.696699C16.4645 0.403806 15.9896 0.403806 15.6967 0.696699C15.4038 0.989592 15.4038 1.46447 15.6967 1.75736L19.9393 6L15.6967 10.2426C15.4038 10.5355 15.4038 11.0104 15.6967 11.3033C15.9896 11.5962 16.4645 11.5962 16.7574 11.3033L21.5303 6.53033ZM0 6.75L21 6.75V5.25L0 5.25L0 6.75Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        {/* Right: featured image */}
        <div className="project-card-media">
          <img
            src={process.env.PUBLIC_URL + "/" + project.image}
            alt={project.title}
            className="project-card-image"
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;